import React from 'react';
import { InfoTooltip } from '../common/InfoTooltip';

interface StatCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  tooltipContent?: string | string[];
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  trend,
  trendValue,
  tooltipContent
}) => {
  const getTrendIcon = () => {
    if (!trend || trend === 'neutral') return null;
    
    return trend === 'up' ? (
      <span className="inline-flex items-center text-green-600 text-sm ml-2">
        <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
        {trendValue}
      </span>
    ) : (
      <span className="inline-flex items-center text-red-600 text-sm ml-2">
        <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
        {trendValue}
      </span>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center justify-between mb-1">
            <p className="text-sm font-medium text-gray-600">{title}</p>
            {tooltipContent && (
              <InfoTooltip
                title={title}
                content={tooltipContent}
                position="bottom"
              />
            )}
          </div>
          <div className="flex items-baseline">
            <p className="text-3xl font-bold text-gray-900">{value}</p>
            {getTrendIcon()}
          </div>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-2">{subtitle}</p>
          )}
        </div>
        {icon && (
          <div className="ml-4 flex-shrink-0">
            <div className="p-3 bg-indigo-50 rounded-lg">
              {icon}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
